// a list of tokens by chain
import { Currency, Token } from '@x-swap-protocol/sdk-core'
import { WXDC_XDC } from '@xspswap/smart-order-router'
import { SupportedChainId } from 'constants/chains'

import { NATIVE_USDC_XDC, nativeOnChain, WRAPPED_NATIVE_CURRENCY, XSP_XDC } from './tokens'

type ChainTokenList = {
  readonly [chainId: number]: Token[]
}

type ChainCurrencyList = {
  readonly [chainId: number]: Currency[]
}

const WRAPPED_NATIVE_CURRENCIES_ONLY: ChainTokenList = Object.fromEntries(
  Object.entries(WRAPPED_NATIVE_CURRENCY)
    .map(([key, value]) => [key, [value]])
    .filter(Boolean)
)

// used to construct intermediary pairs for trading
export const BASES_TO_CHECK_TRADES_AGAINST: ChainTokenList = {
  ...WRAPPED_NATIVE_CURRENCIES_ONLY,
  [SupportedChainId.XDC]: [...WRAPPED_NATIVE_CURRENCIES_ONLY[SupportedChainId.XDC], NATIVE_USDC_XDC, XSP_XDC],
  [SupportedChainId.XDC_TESTNET]: [...WRAPPED_NATIVE_CURRENCIES_ONLY[SupportedChainId.XDC_TESTNET]],
}
export const ADDITIONAL_BASES: { [chainId: number]: { [tokenAddress: string]: Token[] } } = {}
/**
 * Some tokens can only be swapped via certain pairs, so we override the list of bases that are considered for these
 * tokens.
 */
export const CUSTOM_BASES: { [chainId: number]: { [tokenAddress: string]: Token[] } } = {}

/**
 * Shows up in the currency select for swap and add liquidity
 */
export const COMMON_BASES: ChainCurrencyList = {
  [SupportedChainId.XDC]: [nativeOnChain(SupportedChainId.XDC), XSP_XDC, NATIVE_USDC_XDC],
  [SupportedChainId.XDC_TESTNET]: [
    nativeOnChain(SupportedChainId.XDC_TESTNET),
    WRAPPED_NATIVE_CURRENCY[SupportedChainId.XDC_TESTNET] as Token,
  ],
}

// used to construct the list of all pairs we consider by default in the frontend
export const BASES_TO_TRACK_LIQUIDITY_FOR: ChainTokenList = {
  ...WRAPPED_NATIVE_CURRENCIES_ONLY,
  [SupportedChainId.XDC]: [...WRAPPED_NATIVE_CURRENCIES_ONLY[SupportedChainId.XDC], XSP_XDC, NATIVE_USDC_XDC],
  [SupportedChainId.XDC_TESTNET]: [...WRAPPED_NATIVE_CURRENCIES_ONLY[SupportedChainId.XDC_TESTNET]],
}
export const PINNED_PAIRS: { readonly [chainId: number]: [Token, Token][] } = {
  [SupportedChainId.XDC]: [
    [XSP_XDC, WXDC_XDC],
    [NATIVE_USDC_XDC, WXDC_XDC],
  ],
}
